import { createAction } from "@reduxjs/toolkit";

export const setHospital = createAction("patients/setHospital", (id: string) => ({
  payload: { id },
}));
